module.exports = __webpack_public_path__ + "img/cocoa-difference2.6ce8fd40.png";